import React from 'react'

import Login from '../login/A4_index'

function OAuthLogin() {
  return <Login isOAuth={true} />
}

export default OAuthLogin
